<template>
	<main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">CNA Box</a></li>
                            <li><a href="#" title="Pages">Gerencial</a></li>
                            <li>Estágio</li>
                        </ul>
                    </section>

                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Configurar Estágio</b></h2>
                    </div>

                    <b-tabs v-if="estagioCarregado">

                        <b-tab title="Conteúdos do estágio">
                            <br />
                            <estagio-conteudo :estagio-id="estagioId" />
                        </b-tab>

                        <b-tab title="Avaliações">
                            <br />
                            <estagio-avaliacao :estagio-id="estagioId" />
                        </b-tab>

                        <b-tab title="Valores por escola">
                            <br />
                            <escola-estagio :estagio-id="estagioId" />
                        </b-tab>

                        <b-tab title="Modalidades">
                            <br />
                            <estagio-modalidade :estagio-id="estagioId" />
                        </b-tab>

                        <b-tab title="Durações">
                            <br />
                            <estagio-duracao-minima :estagio-id="estagioId" />
                        </b-tab>

                        <b-tab title="Sequências">
                            <br />
                            <estagio-sequencia :estagio-id="estagioId" />
                        </b-tab>

                        <b-tab title="Material Didático">
                            <br />
                            <estoque-item-estagio :estagio-id="estagioId" />
                        </b-tab>

                    </b-tabs>
                </div>
            </div>
        </section>


    </main>

</template>
<script>
    import estagioConteudo from './estagioconteudo'
    import estagioAvaliacao from './estagioavaliacao'
    import escolaEstagio from './escolaestagio'
    import estagioModalidade from './estagiomodalidade'
    import estagioDuracaoMinima from './estagioduracaominima'
    import estagioSequencia from './estagiosequencia'
    import estoqueItemEstagio from './estoqueitemestagio'

    export default {
        name: 'estagio-configuracao',
        components: {
            estagioConteudo,
            estagioAvaliacao,
            escolaEstagio,
            estagioModalidade,
            estagioDuracaoMinima,
            estagioSequencia,
            estoqueItemEstagio
        },
        data: () => ({
            estagioId: 0,
            estagioCarregado: false,
            dialogCreate: false
        }),
        methods: {
            onSaved: function (data) {
                this.$router.push({ path: '/estagio/edit/' + data.data.estagioId });
            },
            onBack: function () {
                this.$router.go(-1);
            }
        },
        mounted() {
            setTimeout(() => {
                this.estagioId = +this.$route.params.id;
                this.estagioCarregado = true;
            }, 500)
            
        }
    };
</script>

